const routes = [
    {
        path: "/prep/student-documents",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'prepstudentdocument_index'
        }
    } ,
    {
        path: "/student/prep/student-documents",
        component: () => import("../pages/student/Index"),
        meta: {
            isStudent: true,
            permission: 'prepstudentdocument_index'
        }
    }
];

export default routes;
